import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Small selectable context menu surface — a soft-tinted card listing options.
 * Matches the Crown Prediction "touch feedback" menu (Figma 5206-133160). Uses
 * the `surface-soft` / `stroke-soft` design tokens.
 */
export const dropdownMenuVariants = cva(
  'flex flex-col gap-2.5 items-center min-w-[94px] max-w-[156px] rounded-[16px] border-2 border-stroke-soft bg-surface-soft p-1.5',
);

/**
 * A single row inside {@link dropdownMenuVariants}. The `selected` variant
 * highlights the active option with the menu's stroke tint.
 */
export const dropdownMenuItemVariants = cva(
  'flex w-full items-center gap-2 rounded-md px-2.5 py-[5px] text-sm text-ink bg-transparent border-none cursor-pointer transition-colors',
  {
    variants: {
      selected: {
        true: 'bg-stroke-soft',
        false: 'hover:bg-stroke-soft/50',
      },
    },
    defaultVariants: {
      selected: false,
    },
  },
);

export type DropdownMenuItemVariantProps = VariantProps<typeof dropdownMenuItemVariants>;
